// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".template-simple__container .v-card__text{background:#fff}.template-simple__container .logo-topbar{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.template-simple__container .logo-topbar h1{display:-webkit-box;display:-ms-flexbox;display:flex;margin-right:10px}.template-simple__container .logo{width:115px}", ""]);
// Exports
module.exports = exports;
